import { render } from "./Introduction.vue?vue&type=template&id=e1927c80"
import script from "./Introduction.vue?vue&type=script&setup=true&lang=js"
export * from "./Introduction.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/var/www/html/lasource-2023/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/cartes-cadeaux/pages/Introduction.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e1927c80"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e1927c80', __exports__)) {
    console.log('reload')
    api.reload('e1927c80', __exports__)
  }
  
  module.hot.accept("./Introduction.vue?vue&type=template&id=e1927c80", () => {
    console.log('re-render')
    api.rerender('e1927c80', render)
  })

}


export default __exports__